// extracted by mini-css-extract-plugin
module.exports = {"s6zaruz":"s6zaruz"};